export const SortDirection = {
  NATURAL: false,
  ASC: "asc",
  DESC: "desc",
};
